module.exports = __webpack_public_path__ + "static/iPhoneBezel-99797c30c53ced3a3cce4dd934075d36.png";